module.exports = __webpack_public_path__ + "img/apply.b7946f57.svg";